<div [innerHTML]="getIconHTML()" [matTooltip]="showTooltip ? tooltip : null"></div>
